import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Tabs, Table, Button, Tag, Tooltip, Icon, Modal, DatePicker, Input, Select, Checkbox } from 'antd';
import moment from 'moment';
import { StyledCard, KPICard, SectionTitle, ReviewMetricCard } from './QualityDashboard.styles';

const { RangePicker } = DatePicker;
const { Option } = Select;

const LISTINGS_METRIC_LABELS = ['Listings in "Good" status', 'Listings in "Warning" status', 'Listings at risk', 'Suspended Listings'];

// Modal detail structure: { reservationId, issues[] } or { reservationId, violations[] }
const listingsData = [
  {
    key: '1',
    listingName: 'Gentle Rain Drive',
    avgScore: 4.7,
    reviewCount: 70,
    qualityStatus: 'Warning',
    qualityStatusColor: '#fa8c16',
    reviewIssues: 2,
    csViolations: 2,
    issuesTooltip:
      '1. Reservation ID: 5038374672\n- Accuracy: Needs maintenance\n- Cleanliness: Noticeable smell\n2. Reservation ID: 5038374672\n- Accuracy: Small space\n- Cleanliness: Pet hair',
    modalReviewIssues: [
      { reservationId: '5038374672', issues: ['Accuracy: Needs maintenance', 'Cleanliness: Noticeable smell'] },
      { reservationId: '5038374672', issues: ['Accuracy: Small space', 'Cleanliness: Pet hair'] }
    ],
    modalViolations: [
      { reservationId: '5038374672', violations: ['Communication: Host encouraged cancellation', 'Cleanliness: Noticeable smell'] },
      { reservationId: '5038374672', violations: ['Accuracy: Needs maintenance; Hair or pet hair', 'Cleanliness: Noticeable smell'] }
    ]
  },
  {
    key: '2',
    listingName: 'Paradise Road',
    avgScore: 4.6,
    reviewCount: 290,
    qualityStatus: 'Warning',
    qualityStatusColor: '#fa8c16',
    reviewIssues: 2,
    csViolations: 2,
    issuesTooltip: '1. Reservation ID: 5503837467\n- Check-in: Unclear instructions',
    modalReviewIssues: [{ reservationId: '5503837467', issues: ['Check-in: Unclear instructions'] }],
    modalViolations: [{ reservationId: '5503837467', violations: ['Check-in: Unclear instructions'] }]
  },
  {
    key: '3',
    listingName: 'House in Nois',
    avgScore: 5.0,
    reviewCount: 802,
    qualityStatus: 'Educate',
    qualityStatusColor: '#52c41a',
    reviewIssues: 1,
    csViolations: 1,
    issuesTooltip: '1. Reservation ID: 3576839201\n- Communication: Slow to respond',
    modalReviewIssues: [{ reservationId: '3576839201', issues: ['Communication: Slow to respond'] }],
    modalViolations: []
  },
  {
    key: '4',
    listingName: 'Retreat',
    avgScore: 4.3,
    reviewCount: 262,
    qualityStatus: 'Suspended',
    qualityStatusColor: '#ff4d4f',
    reviewIssues: 2,
    csViolations: 3,
    issuesTooltip: '',
    modalReviewIssues: [],
    modalViolations: []
  },
  {
    key: '5',
    listingName: 'Calm',
    avgScore: 4.8,
    reviewCount: 68,
    qualityStatus: 'Additional warning',
    qualityStatusColor: '#fa541c',
    reviewIssues: 3,
    csViolations: 3,
    issuesTooltip: '',
    modalReviewIssues: [],
    modalViolations: []
  },
  {
    key: '6',
    listingName: 'Retreat in Galicia',
    avgScore: 4.3,
    reviewCount: 267,
    qualityStatus: 'Removed',
    qualityStatusColor: '#ff4d4f',
    reviewIssues: 2,
    csViolations: 2,
    issuesTooltip: '',
    modalReviewIssues: [],
    modalViolations: []
  },
  {
    key: '7',
    listingName: 'House in Madrid',
    avgScore: 4.8,
    reviewCount: 26,
    qualityStatus: 'Pending removal',
    qualityStatusColor: '#ff7875',
    reviewIssues: 1,
    csViolations: 1,
    issuesTooltip: '',
    modalReviewIssues: [],
    modalViolations: []
  }
];

// Reviews table data (screenshot 2)
const reviewsData = [
  { key: '1', guestName: 'Ioannis Pasmatzis', reservationId: '5038374672', listing: 'Cairn Retreat', listingId: '79546', totalCheckins: 809 },
  { key: '2', guestName: 'Maria Lopez', reservationId: '5503837467', listing: 'Paradise Road', listingId: '79547', totalCheckins: 46 },
  { key: '3', guestName: 'Jade Zendron', reservationId: '3576839201', listing: 'House in Naxos', listingId: '79558', totalCheckins: 256 },
  { key: '4', guestName: 'Alex Buric', reservationId: '5938271630', listing: 'Retreat', listingId: '79532', totalCheckins: 690 }
];

// Reviews Quality metrics (12 cards with trend)
const reviewsMetrics = [
  { label: 'Dirty bathroom', value: '30%', sub: 'of total reviews', trend: 'down', color: '#d46b08' },
  { label: 'Too expensive', value: '25%', sub: 'of total reviews', trend: 'down', color: '#d46b08' },
  { label: 'Slow to respond', value: '15%', sub: 'of total reviews', trend: 'down', color: '#d46b08' },
  { label: 'Overall AVG review score', value: '4.7', sub: '', trend: 'down', color: '#ff4d4f' },
  { label: '5-star rate review', value: '30%', sub: '', trend: 'down', color: '#ff4d4f' },
  { label: 'Cleanliness', value: '4.3', sub: '', trend: 'up', color: '#52c41a' },
  { label: 'Accuracy', value: '4.7', sub: '', trend: 'down', color: '#ff4d4f' },
  { label: 'Communication', value: '4.6', sub: '', trend: 'down', color: '#ff4d4f' },
  { label: 'Check-in', value: '4.7', sub: '', trend: 'down', color: '#ff4d4f' },
  { label: 'Location', value: '4.9', sub: '', trend: 'up', color: '#52c41a' },
  { label: 'Value', value: '4.4', sub: '', trend: 'down', color: '#ff4d4f' },
  { label: 'Reviews that need response', value: '30 / 410', sub: '', trend: 'down', color: '#ff4d4f' }
];

const QualityDashboardDemo3 = () => {
  const [activeTab, setActiveTab] = useState('listings');
  const [compareMoM, setCompareMoM] = useState(true);
  const [dateRange, setDateRange] = useState(null);
  const [hostFilter, setHostFilter] = useState('');
  const [listingFilter, setListingFilter] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [cityFilter, setCityFilter] = useState('');
  const [qualityStatusFilter, setQualityStatusFilter] = useState('ALL');
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [selectMetricsVisible, setSelectMetricsVisible] = useState(false);
  const [visibleListingsMetrics, setVisibleListingsMetrics] = useState([true, true, true, true]);
  const [visibleReviewsMetrics, setVisibleReviewsMetrics] = useState(reviewsMetrics.map(() => true));
  const [issuesModalVisible, setIssuesModalVisible] = useState(false);
  const [selectedListingForModal, setSelectedListingForModal] = useState(null);

  const clearFilters = () => {
    setDateRange(null);
    setHostFilter('');
    setListingFilter('');
    setCountryFilter('');
    setCityFilter('');
    setQualityStatusFilter('ALL');
  };

  const removeFilter = key => {
    if (key === 'dateRange') setDateRange(null);
    if (key === 'host') setHostFilter('');
    if (key === 'listing') setListingFilter('');
    if (key === 'country') setCountryFilter('');
    if (key === 'city') setCityFilter('');
    if (key === 'qualityStatus') setQualityStatusFilter('ALL');
  };

  const activeFilterTags = [];
  if (dateRange && dateRange[0] && dateRange[1]) {
    activeFilterTags.push({
      key: 'dateRange',
      label: `From: ${moment(dateRange[0]).format('YYYY-MM-DD')} To: ${moment(dateRange[1]).format('YYYY-MM-DD')}`
    });
  }
  if (qualityStatusFilter && qualityStatusFilter !== 'ALL') {
    activeFilterTags.push({ key: 'qualityStatus', label: `Status: ${qualityStatusFilter}` });
  }
  if (hostFilter.trim()) activeFilterTags.push({ key: 'host', label: `Host: ${hostFilter.trim()}` });
  if (listingFilter.trim()) activeFilterTags.push({ key: 'listing', label: `Listing: ${listingFilter.trim()}` });
  if (countryFilter.trim()) activeFilterTags.push({ key: 'country', label: `Country: ${countryFilter.trim()}` });
  if (cityFilter.trim()) activeFilterTags.push({ key: 'city', label: `City: ${cityFilter.trim()}` });
  const hasActiveFilters = activeFilterTags.length > 0;

  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  }, [activeTab]);

  const listingsColumns = [
    {
      title: 'Listing name',
      dataIndex: 'listingName',
      key: 'listingName',
      width: 220,
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 32, height: 32, background: '#e8e8e8', borderRadius: 4, flexShrink: 0 }} />
          <span>{text}</span>
        </div>
      )
    },
    {
      title: 'Average review score',
      key: 'avgScore',
      width: 160,
      render: (_, r) => (
        <span>
          {r.avgScore} ({r.reviewCount})
        </span>
      )
    },
    {
      title: 'Airbnb quality status',
      dataIndex: 'qualityStatus',
      key: 'qualityStatus',
      width: 160,
      render: (_, r) => <Tag color={r.qualityStatusColor}>{r.qualityStatus}</Tag>
    },
    {
      title: 'Airbnb review issues',
      dataIndex: 'reviewIssues',
      key: 'reviewIssues',
      width: 140,
      render: (val, record) =>
        record.issuesTooltip ? (
          <Tooltip title={<pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: 12 }}>{record.issuesTooltip}</pre>}>
            <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>{val}</span>
          </Tooltip>
        ) : (
          val
        )
    },
    {
      title: 'Airbnb CS violations',
      dataIndex: 'csViolations',
      key: 'csViolations',
      width: 140
    },
    {
      title: '',
      key: 'action',
      width: 100,
      render: (_, record) => (
        <Button
          type="link"
          size="small"
          style={{ padding: 0 }}
          onClick={() => {
            setSelectedListingForModal(record);
            setIssuesModalVisible(true);
          }}
        >
          Read more
        </Button>
      )
    }
  ];

  const reviewsColumns = [
    { title: 'Guest name', dataIndex: 'guestName', key: 'guestName', width: 180 },
    { title: 'Reservation ID', dataIndex: 'reservationId', key: 'reservationId', width: 130 },
    { title: 'Listing', dataIndex: 'listing', key: 'listing', width: 160 },
    { title: 'Listing ID', dataIndex: 'listingId', key: 'listingId', width: 100 },
    {
      title: 'Channel',
      key: 'channel',
      width: 120,
      render: () => (
        <div style={{ display: 'flex', gap: 4 }}>
          {[1, 2, 3].map(i => (
            <div key={i} style={{ width: 20, height: 20, borderRadius: '50%', background: i === 1 ? '#ff5a5f' : '#e8e8e8' }} />
          ))}
        </div>
      )
    },
    { title: 'Total check-ins', dataIndex: 'totalCheckins', key: 'totalCheckins', width: 120 }
  ];

  return (
    <StyledCard
      title={
        <span>
          Airbnb Quality Dashboard (Demo 3 — Hostaway){' '}
          <a
            href="https://youtu.be/pzvZRbNbD4I?t=953"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: 400, fontSize: 12, marginLeft: 8 }}
          >
            Reference Link - Hostaway
          </a>
          <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>
          <a
            href="https://support.hostaway.com/hc/en-us/articles/31521446471323-Listings-Hosting-Quality-Dashboard"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: 400, fontSize: 12 }}
          >
            Reference Link 2 - Hostaway
          </a>
        </span>
      }
    >
      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        <Tabs.TabPane tab="Listings Quality" key="listings">
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 8,
              marginBottom: 16,
              padding: '12px 0',
              borderBottom: '1px solid #f0f0f0'
            }}
          >
            <Button icon="filter" onClick={() => setFiltersVisible(true)}>
              Filters
              {hasActiveFilters && (
                <Tag color="blue" style={{ marginLeft: 6 }}>
                  {activeFilterTags.length}
                </Tag>
              )}
            </Button>
            {activeFilterTags.map(({ key, label }) => (
              <Tag key={key} closable onClose={() => removeFilter(key)} color="blue">
                {label}
              </Tag>
            ))}
            {hasActiveFilters && (
              <a onClick={clearFilters} style={{ marginLeft: 'auto', fontSize: 13 }}>
                Clear filters
              </a>
            )}
            <Button
              type="primary"
              icon="download"
              style={{ marginLeft: 8 }}
              onClick={() => {
                /* demo download */
              }}
            >
              Download report
            </Button>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
            <SectionTitle style={{ marginBottom: 0 }}>Metrics</SectionTitle>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {compareMoM && (
                <Tag closable onClose={() => setCompareMoM(false)} color="blue">
                  Compare: MoM
                </Tag>
              )}
              <a style={{ fontSize: 13 }} onClick={() => setSelectMetricsVisible(true)}>
                Select metrics ({visibleListingsMetrics.filter(Boolean).length})
              </a>
            </div>
          </div>
          <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            {visibleListingsMetrics[0] && (
              <Col xs={24} sm={12} md={6}>
                <KPICard>
                  <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Listings in "Good" status</div>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                    <span style={{ fontSize: 22, fontWeight: 600, color: '#52c41a' }}>230 / 410</span>
                    <Icon type="arrow-up" style={{ color: '#1890ff', fontSize: 14 }} />
                  </div>
                </KPICard>
              </Col>
            )}
            {visibleListingsMetrics[1] && (
              <Col xs={24} sm={12} md={6}>
                <KPICard>
                  <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Listings in "Warning" status</div>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                    <span style={{ fontSize: 22, fontWeight: 600, color: '#fa8c16' }}>40 / 410</span>
                    <Icon type="arrow-up" style={{ color: '#ff4d4f', fontSize: 14 }} />
                  </div>
                </KPICard>
              </Col>
            )}
            {visibleListingsMetrics[2] && (
              <Col xs={24} sm={12} md={6}>
                <KPICard>
                  <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Listings at risk</div>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                    <span style={{ fontSize: 22, fontWeight: 600, color: '#ff4d4f' }}>30 / 410</span>
                    <Icon type="arrow-up" style={{ color: '#ff4d4f', fontSize: 14 }} />
                  </div>
                </KPICard>
              </Col>
            )}
            {visibleListingsMetrics[3] && (
              <Col xs={24} sm={12} md={6}>
                <KPICard>
                  <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Suspended Listings</div>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                    <span style={{ fontSize: 22, fontWeight: 600, color: '#fa8c16' }}>10 / 410</span>
                    <Icon type="arrow-up" style={{ color: '#ff4d4f', fontSize: 14 }} />
                  </div>
                </KPICard>
              </Col>
            )}
          </Row>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <SectionTitle style={{ marginBottom: 0 }}>Listings</SectionTitle>
          </div>
          <Table columns={listingsColumns} dataSource={listingsData} pagination={{ pageSize: 10 }} size="small" />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Reviews Quality" key="reviews">
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 8,
              marginBottom: 16,
              padding: '12px 0',
              borderBottom: '1px solid #f0f0f0'
            }}
          >
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
              <Button icon="filter" onClick={() => setFiltersVisible(true)}>
                Filters
                {hasActiveFilters && (
                  <Tag color="blue" style={{ marginLeft: 6 }}>
                    {activeFilterTags.length}
                  </Tag>
                )}
              </Button>
              {activeFilterTags.map(({ key, label }) => (
                <Tag key={key} closable onClose={() => removeFilter(key)} color="blue">
                  {label}
                </Tag>
              ))}
              {hasActiveFilters && (
                <a onClick={clearFilters} style={{ fontSize: 13 }}>
                  Clear filters
                </a>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Button style={{ color: '#1890ff' }}>Category breakdown</Button>
              <Button
                type="primary"
                icon="download"
                onClick={() => {
                  /* demo download */
                }}
              >
                Download report
              </Button>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
            <SectionTitle style={{ marginBottom: 0 }}>Metrics</SectionTitle>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {compareMoM && (
                <Tag closable onClose={() => setCompareMoM(false)} color="blue">
                  Compare: MoM
                </Tag>
              )}
              <a style={{ fontSize: 13 }} onClick={() => setSelectMetricsVisible(true)}>
                Select metrics ({visibleReviewsMetrics.filter(Boolean).length})
              </a>
            </div>
          </div>
          <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            {reviewsMetrics.map((m, idx) =>
              visibleReviewsMetrics[idx] ? (
                <Col xs={24} sm={12} md={6} key={idx}>
                  <ReviewMetricCard size="small">
                    <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>{m.label}</div>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                      <span style={{ fontSize: 18, fontWeight: 600, color: m.color }}>{m.value}</span>
                      <Icon
                        type={m.trend === 'up' ? 'arrow-up' : 'arrow-down'}
                        style={{ color: m.trend === 'up' ? '#52c41a' : '#ff4d4f', fontSize: 12 }}
                      />
                    </div>
                    {m.sub && <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 2 }}>{m.sub}</div>}
                  </ReviewMetricCard>
                </Col>
              ) : null
            )}
          </Row>

          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 12, gap: 8 }}>
            <SectionTitle style={{ marginBottom: 0 }}>Reviews</SectionTitle>
            <Button type="link" style={{ padding: 0, fontSize: 14 }}>
              Respond to reviews
            </Button>
            <Button.Group size="small" style={{ marginLeft: 'auto' }}>
              <Button type="primary">Per reservation</Button>
              <Button>Per listing</Button>
            </Button.Group>
          </div>
          <Table columns={reviewsColumns} dataSource={reviewsData} pagination={{ pageSize: 10 }} size="small" />
        </Tabs.TabPane>
      </Tabs>

      <Modal
        title="Filters"
        visible={filtersVisible}
        onCancel={() => setFiltersVisible(false)}
        footer={
          <div>
            <Button style={{ marginRight: 8 }} onClick={() => setFiltersVisible(false)}>
              Cancel
            </Button>
            <Button type="primary" onClick={() => setFiltersVisible(false)}>
              Apply
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: 12 }}>
          <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>Date Range</div>
          <RangePicker value={dateRange} onChange={setDateRange} style={{ width: '100%' }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>Host name / ID</div>
          <Input placeholder="e.g. Property Manager A" value={hostFilter} onChange={e => setHostFilter(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>Listing name / ID</div>
          <Input placeholder="e.g. Seaside View Apartment" value={listingFilter} onChange={e => setListingFilter(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>Country</div>
          <Input placeholder="e.g. Italy" value={countryFilter} onChange={e => setCountryFilter(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>City</div>
          <Input placeholder="e.g. Napoli" value={cityFilter} onChange={e => setCityFilter(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>Latest Quality Status</div>
          <Select value={qualityStatusFilter} onChange={setQualityStatusFilter} style={{ width: '100%' }}>
            <Option value="ALL">ALL</Option>
            <Option value="Good">Good</Option>
            <Option value="Educate">Educate</Option>
            <Option value="Warn">Warn</Option>
            <Option value="Probation">Probation</Option>
            <Option value="Removed">Removed</Option>
          </Select>
        </div>
      </Modal>

      <Modal
        title="Select metrics"
        visible={selectMetricsVisible}
        onCancel={() => setSelectMetricsVisible(false)}
        footer={
          <Button type="primary" onClick={() => setSelectMetricsVisible(false)}>
            OK
          </Button>
        }
      >
        {activeTab === 'listings' ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {LISTINGS_METRIC_LABELS.map((label, idx) => (
              <Checkbox
                key={idx}
                checked={visibleListingsMetrics[idx]}
                onChange={e => {
                  const next = [...visibleListingsMetrics];
                  next[idx] = e.target.checked;
                  setVisibleListingsMetrics(next);
                }}
              >
                {label}
              </Checkbox>
            ))}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {reviewsMetrics.map((m, idx) => (
              <Checkbox
                key={idx}
                checked={visibleReviewsMetrics[idx]}
                onChange={e => {
                  const next = [...visibleReviewsMetrics];
                  next[idx] = e.target.checked;
                  setVisibleReviewsMetrics(next);
                }}
              >
                {m.label}
              </Checkbox>
            ))}
          </div>
        )}
      </Modal>

      <Modal
        title="Airbnb issues, cancellations and violations"
        visible={issuesModalVisible}
        onCancel={() => setIssuesModalVisible(false)}
        footer={
          <Button type="primary" onClick={() => setIssuesModalVisible(false)}>
            Ok
          </Button>
        }
        width={560}
      >
        {selectedListingForModal && (
          <>
            {(selectedListingForModal.modalReviewIssues || []).length > 0 && (
              <div style={{ marginBottom: 24 }}>
                <div style={{ fontWeight: 600, marginBottom: 12, color: '#262626' }}>Airbnb review issues</div>
                {(selectedListingForModal.modalReviewIssues || []).map((item, idx) => (
                  <div key={idx} style={{ marginBottom: 16 }}>
                    <div style={{ marginBottom: 4 }}>
                      <span style={{ marginRight: 8 }}>Reservation ID: {item.reservationId}</span>
                      <Button type="link" size="small" style={{ padding: 0, fontSize: 13 }}>
                        Review information
                      </Button>
                    </div>
                    <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: '#595959' }}>
                      {(item.issues || []).map((issue, i) => (
                        <li key={i}>{issue}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
            {(selectedListingForModal.modalViolations || []).length > 0 && (
              <div>
                <div style={{ fontWeight: 600, marginBottom: 12, color: '#262626' }}>Airbnb violations</div>
                {(selectedListingForModal.modalViolations || []).map((item, idx) => (
                  <div key={idx} style={{ marginBottom: 16 }}>
                    <div style={{ marginBottom: 4 }}>
                      <span style={{ marginRight: 8 }}>Reservation ID: {item.reservationId}</span>
                      <Button type="link" size="small" style={{ padding: 0, fontSize: 13 }}>
                        Review information
                      </Button>
                    </div>
                    <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: '#595959' }}>
                      {(item.violations || []).map((v, i) => (
                        <li key={i}>{v}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
            {(selectedListingForModal.modalReviewIssues || []).length === 0 && (selectedListingForModal.modalViolations || []).length === 0 && (
              <div style={{ color: '#8c8c8c', fontSize: 13 }}>No issues or violations for this listing.</div>
            )}
          </>
        )}
      </Modal>
    </StyledCard>
  );
};

export default QualityDashboardDemo3;
